import { render, staticRenderFns } from "./EventPlace.vue?vue&type=template&id=79db5278&scoped=true"
import script from "./EventPlace.vue?vue&type=script&lang=js"
export * from "./EventPlace.vue?vue&type=script&lang=js"
import style0 from "./EventPlace.vue?vue&type=style&index=0&id=79db5278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79db5278",
  null
  
)

export default component.exports